export const INITIAL_MAX_ITEMS_TO_RETURN = 20;
export const LOAD_MORE_INCREMENT = 10;
